export default __webpack_public_path__ + "static/media/flower50.59fd0e62.png";